<template>
  <div class="language-switcher">
    <el-dropdown @command="handleCommand" trigger="click">
      <span class="language-trigger">
        {{ currentLanguage === 'zh' ? '中文' : 'English' }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh" :class="{ active: currentLanguage === 'zh' }">
          中文
        </el-dropdown-item>
        <el-dropdown-item command="en" :class="{ active: currentLanguage === 'en' }">
          English
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  computed: {
    currentLanguage() {
      return this.$i18n.locale
    }
  },
  methods: {
    handleCommand(command) {
      this.$i18n.locale = command
      localStorage.setItem('language', command)
      // 触发语言切换事件，通知其他组件
      this.$root.$emit('language-changed', command)
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: inline-block;
  margin-left: 20px;
}

.language-trigger {
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 14px;
  padding: 15px 20px;
  display: inline-flex;
  align-items: center;
  transition: color 0.3s;
}

.language-trigger:hover {
  color: var(--accent-light);
}

::v-deep .el-dropdown-menu {
  background-color: var(--bg-card);
  border: 1px solid var(--border-color);
}

::v-deep .el-dropdown-menu__item {
  color: var(--text-secondary);
}

::v-deep .el-dropdown-menu__item:hover {
  background-color: var(--bg-card-hover);
  color: var(--text-primary);
}

::v-deep .el-dropdown-menu__item.active {
  color: var(--accent-light);
  font-weight: bold;
}
</style>

